import React from "react";

import { EntryButtonStyled } from "./EntryButtonStyled";
import { FileItem } from "./FileItem";
import { Entry } from "../types";

interface IProps extends Entry {
  checked: boolean;
  isDisabled: boolean;
  onClick: React.MouseEventHandler;
}

export const EntryButton: React.FC<IProps> = (
  {
    id,
    name,
    type,
    size,
    createdTime,
    checked,
    isDisabled,
    onClick,
  }
) => (
  <EntryButtonStyled
    type="button"
    borderRadius="0"
    color="black"
    value={[id, type]}
    onClick={onClick}
    disabled={isDisabled}
  >
    <FileItem
      name={name}
      type={type}
      size={size}
      createdTime={createdTime}
      checked={checked}
    />
  </EntryButtonStyled>
);
